import { ChangeDetectionStrategy, Component, ElementRef, EventEmitter, HostBinding, Input, Output, ViewChild } from "@angular/core";
import { VideoHotspot } from "@pcp/core/interfaces";
import { ResizedEvent } from "@pcp/core/util";


@Component({
    selector: 'pcp-video-hotspots',
    templateUrl: './video-hotspots.component.html',
    styleUrls: ['./video-hotspots.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: []
})
export class VideoHotspotsComponent {

    @Input() @HostBinding('class.debug') debug = false;

    @Input() visibleHotspots: VideoHotspot[] = [];

    @Input() slideId?: number;

    @Output() hotspotClicked = new EventEmitter<VideoHotspot>();

    @ViewChild('videoHotspotsContainer', { static: true }) videoHotspotsContainer!: ElementRef<HTMLDivElement>;
    @ViewChild('videoHotspots', { static: true }) videoHotspots!: ElementRef<SVGSVGElement>;

    private readonly scaleFactor16to9 = 16 / 9;

    onVideoResized(event: ResizedEvent, maxWidth: number, maxHeight: number) {
        const width = event.newWidth;
        const height = this.calc16To9Height(width);

        let newWidth = Math.min(maxWidth, this.calc16To9Width(height));
        let newHeight = Math.min(maxHeight, this.calc16To9Height(width));

        // recalculate in order to make sure both dimensions fit into the screen / the player
        newWidth = this.calc16To9Width(newHeight);
        newHeight = this.calc16To9Height(newWidth);

        this.videoHotspots.nativeElement.style.height = `${newHeight}px`;
        this.videoHotspotsContainer.nativeElement.style.top = `${(maxHeight - newHeight) / 2}px`;
        this.videoHotspotsContainer.nativeElement.style.left = `${(maxWidth - newWidth) / 2}px`;
        this.videoHotspotsContainer.nativeElement.style.width = `${newWidth}px`;
        this.videoHotspotsContainer.nativeElement.style.height = `calc(${newHeight}px - 3.5em)`; // {desired height}-{video playbar}
    }

    calc16To9Width = (height: number) => this.scaleFactor16to9 * height;
    calc16To9Height = (width: number) => width / this.scaleFactor16to9;

}
